import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import styles from '../css/loginStyles';
import { Fab, Link, Button, Paper, CircularProgress } from '@material-ui/core';
import classNames from 'classnames';
import TermsOfService from './TermsOfService';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { withMsal } from '@azure/msal-react';
import TextField from '@material-ui/core/TextField';
import FidelityIcon from '../../../../assets/fbs.svg';
import ShowMoreIcon from '../../../../assets/show-more.svg';
import ShowLessIcon from '../../../../assets/show-less.svg';
import { FETCH_TRM_OF_SVC_REQUEST } from '../../../../redux/constants/shared/legalsConstants';
import SignIn from '../../cognito/components/SignIn';
import { con } from '../../../../shared/config/config';
import LoginNote from '../../loginuser/components/LoginNote';

const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => (
    <TextField
        label={label}
        error={touched && error ? true : false}
        helperText={touched && error}
        {...input}
        {...custom}
    />
);

class Login extends React.Component {
    state = {
        openTerms: false,
        openFidsafeForm: true,
        loginError: null,
        isLoggingIn: false
    };

    /**
     * Trigger MSAL loginRedirect for advisor/default SSO strategies.
     * Cognito and OAuth2 strategies are NOT affected — they keep their form POST flow.
     */
    handleMsalLogin = async (e) => {
        e?.preventDefault();

        this.setState({ loginError: null, isLoggingIn: true });

        const { msalContext } = this.props;

        if (!msalContext?.instance) {
            console.error('MSAL not available');
            this.setState({
                loginError: 'Authentication service is not available. Please refresh the page and try again.',
                isLoggingIn: false
            });
            return;
        }

        try {
            await msalContext.instance.loginRedirect({
                scopes: ['openid', 'profile', 'User.Read']
            });
        } catch (err) {
            console.error('MSAL loginRedirect failed', err);

            let errorMessage = 'Login failed. Please try again.';
            if (err.errorCode === 'popup_window_error' || err.errorCode === 'user_cancelled') {
                errorMessage = 'Login was cancelled. Please try again.';
            } else if (err.errorCode === 'interaction_in_progress') {
                errorMessage = 'A login is already in progress. Please wait.';
            } else if (err.errorCode === 'network_error') {
                errorMessage = 'Network error. Please check your connection and try again.';
            } else if (err.message) {
                errorMessage = `Login failed: ${err.message}`;
            }

            this.setState({ loginError: errorMessage, isLoggingIn: false });
        }
    };

    handleOpenModal = (type) => {
        if (type === 'openTerms') {
            if (!this.props.trmsOfSvcfetching && (!this.props.trmsOfSvcContent || this.props.trmsOfSvcContent.length === 0))
                this.props.fetchTrmsOfSvcContent();
            this.setState({ [type]: true });
        }
        else if (type === 'openPolicy') {
            //open fidelity privacy policy
            window.open(con.PRIVACY_POLICY, '_blank'); 
        }
        
    }

    handleCloseModal = (type) => {
        this.setState({ [type]: false });
    }

    generateInlineLink(flag, label) {
        const { classes } = this.props;
        return <Link data-test='inlineLink' className={classes.link} onClick={() => this.handleOpenModal(flag)}>{label}</Link>
    }

    renderFidelityLoginContent() {
        const { classes } = this.props;
        return (
            <div className={classes.statement} style={{ marginTop: '1rem' }}>
                Fidsafe<sup>&reg;</sup> for Business (the "Service") offers a secure, digital document sharing facility (a "vault"). 
                The Service is operated by Fidelity Technology Group, LLC, a Fidelity affiliate, is made available to you as a Fidelity customer at no additional charge, and is subject to certain limitations and
                restrictions. Note that your Fidelity log-in credentials provide access to client vault via Fidelity.com.
                However, the {this.generateInlineLink('openTerms', 'Terms of Service ')} that govern your use of client vault differ from those applicable to your experience on Fidelity.com. Please carefully review
                the FidSafe for Business {this.generateInlineLink('openTerms', 'Terms of Service ')} and the Fidelity {this.generateInlineLink('openPolicy', 'Privacy Policy')} prior to use.
            </div>
        )
    }

    renderNonFidelityLoginContent() {
        const { classes } = this.props;
        return (
            <div className={classes.statement} style={{ marginTop: '1rem' }}>
                Fidsafe<sup>&reg;</sup> for Business (the "Service") offers a secure, digital document sharing facility (a "vault").
                The Service is operated by Fidelity Technology Group, LLC, a Fidelity affiliate, is made available to you as a Fidelity customer at no additional charge, and is subject to certain limitations and
                restrictions. 
                However, the {this.generateInlineLink('openTerms', 'Terms of Service ')} that govern your use of client vault differ from those applicable to your experience on Fidelity.com. Please carefully review
                the FidSafe for Business {this.generateInlineLink('openTerms', 'Terms of Service ')} and the Fidelity {this.generateInlineLink('openPolicy', 'Privacy Policy')} prior to use.            
            </div>
        )
    }

    renderLinkAndTos(thirdParty) {
        const { classes, features } = this.props;
        if (thirdParty)
            return this.renderNonFidelityLoginContent()
        else
            return <>
                {features['nonFidelityLogin'] === false &&
                    this.renderFidelityLoginContent()
                }
                {Boolean(features['nonFidelityLogin']) &&
                    this.renderNonFidelityLoginContent()
                }
            </>
    }

    renderLoginContent(title, description, children) {
      const { classes, features } = this.props;
      const { openFidsafeForm } = this.state;
      const showNote = features['showResetPasswordNote'];
      const resetPasswordNoteDate = features['resetPasswordNoteDate'];
    
      const renderLoginForm = (key, link, buttonText) => (
        <React.Fragment key={key}>
          <form action={`auth-login/${link}`}>
            <div className={classes.row}>
              <Button
                className={classes.loginBtn}
                variant="outlined"
                type="submit"
                fullWidth
                style={{ marginTop: '1rem', width: '100%' }}
              >
                <img className={classes.loginBtnIcon} src={FidelityIcon} alt={`Login with ${buttonText}`} />
                {`LOG IN WITH ${buttonText}`}
              </Button>
            </div>
          </form>
        </React.Fragment>
      );
    
      const renderFidsafeForm = (key, link) => (
        <React.Fragment key={`fidsafe-${key}`}>
          {openFidsafeForm && (
            <div className={classes.cognitoLogincontainer}>
              <SignIn endpoint={`auth-login/${link}`} />
            </div>
          )}
        </React.Fragment>
      );
    
      const renderLoginNote = () => (
        <LoginNote showNote={showNote} resetPasswordNoteDate={resetPasswordNoteDate} />
      );
    
      const renderFidsafeToggle = () => (
        <div
          className={classes.NotaFidelityCustomer}
          onClick={() => this.setState({ openFidsafeForm: !openFidsafeForm })}
        >
          {openFidsafeForm ? (
            <img src={ShowLessIcon} alt="Collapse" />
          ) : (
            <img src={ShowMoreIcon} alt="Expand" />
          )}
          <div className={classes.externalCustomertext}>Not a Fidelity Customer</div>
        </div>
      );
    
      const loginMap = features.loginLayout.reduce((acc, element) => {
        const key = Object.keys(element)[0];
        acc[key] = element[key].type;
        return acc;
      }, {});
    
      return (
        <div className={classes.loginContent}>
          <div className={classes.subtitles}>
            <Typography variant="h5" className={classes.subtitle}>{title}</Typography>
            <Typography
              variant="subtitle1"
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: description }}
            />
            {children}
          </div>
    
          {(loginMap['fidelity-login'] === 'default' || loginMap['fidelity-login-default'] === 'default') &&
            renderLoginForm('fidelity-login-default', 'default', 'FIDELITY')}
    
          {loginMap['fidsafe-login-idaas'] === 'idaas' && (
            <React.Fragment key="fidsafe-login-idaas">
              {renderFidsafeToggle()}
              {openFidsafeForm && (
                <>
                  {renderLoginNote()}
                  {renderLoginForm('fidsafe-login-idaas', 'idaas', 'FIDSAFE')}
                </>
              )}
              {renderFidsafeForm('fidsafe-login-idaas', 'idaas')}
            </React.Fragment>
          )}
    
    {['fidsafe-login'].map((key) => {
  const link = loginMap[key];
  const hasFidelityLogin =
    loginMap['fidelity-login'] === 'default' || loginMap['fidelity-login-default'] === 'default';
 
  if (link === 'cognito') {
    if (hasFidelityLogin) {
      return (
        <React.Fragment key={key}>
          {renderFidsafeToggle()}
          {openFidsafeForm && (
            <>
              {renderFidsafeForm(key, link)}
            </>
          )}
        </React.Fragment>
      );
    } else {
      return renderFidsafeForm(key, link);
    }
  }
 
  if (link === 'idaas') {
    return (
      <React.Fragment key={key}>
        {renderLoginNote()}
        {renderLoginForm('fidelity-login', link, 'FIDELITY')}
        {renderFidsafeForm(key, link)}
      </React.Fragment>
    );
  }
 
  if (link === 'idaas-signup') {
    return renderLoginForm(key, link, 'FIDELITY');
  }
 
  return null;
})}
 
          {features.thirdPartyLoginLayout
            .filter((element) => Object.keys(element).includes('fidsafe-login'))
            .map((element) => {
              const key = Object.keys(element)[0];
              const link = element[key].type;
              return (
                <React.Fragment key={`thirdparty-${key}`}>
                  <div style={{ display: 'none' }}>
                    <SignIn endpoint={`auth-login/${link}`} />
                  </div>
                </React.Fragment>
              );
            })}
        </div>
      );
    }

      renderThirdPartyLoginContent(title, description, children) {
        const { classes, features } = this.props;
        return (
          <div className={classes.loginContent}>
            <div data-test="thirdPartyLoginCont" className={classes.subtitles}>
              <Typography variant='h5' className={classes.subtitle}>{title}</Typography>
              <Typography variant='subtitle1' className={classes.description}
                dangerouslySetInnerHTML={{ __html: description }}></Typography>
              {children}
            </div>
            {this.props.features.thirdPartyLoginLayout.map(function (element) {
              const key = Object.keys(element)[0];
              const link = element[key].type;
              if (key === 'fidsafe-login') {
                return (
                  <React.Fragment key={'fidsafe-login'}>
                    <div className={classes.cognitoLogincontainer}>
                      <SignIn endpoint={`auth-login/${link}`} />
                    </div>
                  </React.Fragment>
                );
              } else {
                return null;
              }
            })}
          </div>
        );
      }
      

    renderAdvisorLoginContent(advisorLink) {
        const { classes } = this.props;
        return <div className={classes.advisorBox} key={advisorLink}>
                <div className={classes.advisorBoxContent}>
                <Typography className={classes.subtitle2}> Are you a Fidelity representative?</Typography>
                <Link className={classNames(classes.link, classes.centerText)} onClick={this.handleMsalLogin} style={{ cursor: 'pointer' }}>
                    <Typography className={classes.loginLink} style={{ fontSize: 16 }}>Login</Typography>
                </Link>
            </div>
        </div>
    }

    renderContent() {
        const that = this;
        let thirdParty = false
        const { classes, unauthorized, loggedIn, error } = this.props;

        if (unauthorized) {
            const discriminator = loggedIn.discriminator;
            const contactOption = discriminator === 'advisor' ? 'administrator' : 'Fidelity advisor'; // if user is logged as a advisor, he/she should contact admin
            const title = "We're sorry. It looks like there's a problem.";
            const description = `Your account is not authorized to access this resource. Please contact your ${contactOption} for further assistance.`;
            const buttonLabel = 'back';
            let errMsg;
            if (error && error.response && error.response.data)
                errMsg = <li className={classes.errMsg}>{error.response.data.errMsg}</li>
            return <div data-test='loginContentContainer' className={classes.loginContent}>
                <div className={classes.subtitles}>
                    <Typography variant='h5' className={classes.subtitle}>{title}</Typography>
                    <Typography variant='subtitle1' className={classes.description}>{description}</Typography>
                    {
                        errMsg
                    }
                </div>
                <form data-test='logout-form' action='/logout'>
                    <div className={classes.row} >
                        <Fab variant='extended' type='submit' color='primary' className={classes.button} >
                            {buttonLabel}
                        </Fab>
                    </div>
                </form>
            </div>
        }
        else {
            let title = 'Welcome to your vault';
            let description = 'Vault is supported by FidSafe<sup>&reg;</sup> for Business to securely and digitally share documents';
            const location = window.location.pathname;

            const thirdPartyLogin = this.props.features.thirdPartyLoginLayout.filter(function (element) {
                const loginUrls = Object.values(element)[0]['login-urls'];
                return loginUrls.includes(location);
            })
            thirdParty = (thirdPartyLogin.length > 0);
            return <>
                { !thirdParty ? this.renderLoginContent(title, description) : this.renderThirdPartyLoginContent(title, description)}
                {this.props.features.loginLayout.map(function (element) {
                    const key = Object.keys(element)[0];
                    const link = element[key].type;
                    if (key === 'rep-login' && !thirdParty) {
                       return (that.renderAdvisorLoginContent(`auth-login/${link}`)) 
                    } else {
                        return (null)
                    }
                })}
                {this.renderLinkAndTos(thirdParty)}
            </>
        }
    }

    renderProgressBar() {
        const { classes } = this.props;
        return <div className={classes.loaderholder} >
            <Paper elevation={3} className={classes.loader}>
                <CircularProgress />
                <div className={classes.loadingtext}>Loading...</div>
            </Paper>
        </div>
    }

    render() {
        const { classes } = this.props;
        return (

            <React.Fragment>
                <div className={classes.root}>

                    <TermsOfService
                        title='Terms of Service'
                        openModal={this.state.openTerms}
                        showAction={false}
                        handleCloseCallback={() => { this.handleCloseModal('openTerms') }} />

                    <div className={classes.sideBar} />

                    <main className={classes.main}>
                        {this.renderContent()}
                    </main>
                </div>
                {(this.props.signin.signinProgress || this.props.userDetails.getUserDetailsProgress) ? this.renderProgressBar() : null}
            </React.Fragment>

        );
    }
}

Login.propTypes = {
    msalContext: PropTypes.shape({
        instance: PropTypes.shape({
            loginRedirect: PropTypes.func,
            getAllAccounts: PropTypes.func,
        }),
    }),
    classes: PropTypes.shape({
        root: PropTypes.string,
        main: PropTypes.string,
        sideBar: PropTypes.string,
        loginContent: PropTypes.string,
        subtitles: PropTypes.string,
        subtitle: PropTypes.string,
        subtitle2: PropTypes.string,
        description: PropTypes.string,
        row: PropTypes.string,
        loginBtn: PropTypes.string,
        loginBtnIcon: PropTypes.string,
        statement: PropTypes.string,
        link: PropTypes.string,
        centerText: PropTypes.string,
        advisorBox: PropTypes.string,
        advisorBoxContent: PropTypes.string,
        loginLink: PropTypes.string,
        cognitoLogincontainer: PropTypes.string,
        NotaFidelityCustomer: PropTypes.string,
        externalCustomertext: PropTypes.string,
        button: PropTypes.string,
        errMsg: PropTypes.string,
        loaderholder: PropTypes.string,
        loader: PropTypes.string,
        loadingtext: PropTypes.string,
    }).isRequired,
    unauthorized: PropTypes.bool,
    loggedIn: PropTypes.object,
    error: PropTypes.object,
    trmsOfSvcContent: PropTypes.array,
    trmsOfSvcfetching: PropTypes.bool,
    features: PropTypes.shape({
        loginLayout: PropTypes.array,
        thirdPartyLoginLayout: PropTypes.array,
        nonFidelityLogin: PropTypes.any,
        showResetPasswordNote: PropTypes.bool,
        resetPasswordNoteDate: PropTypes.string,
    }),
    signin: PropTypes.shape({
        signinProgress: PropTypes.bool,
    }),
    userDetails: PropTypes.shape({
        getUserDetailsProgress: PropTypes.bool,
    }),
    fetchTrmsOfSvcContent: PropTypes.func,
};

const mapStateToProps = state => {
    return {
        loggedIn: state.login,
        error: state.homeReducer.error,
        trmsOfSvcContent: state.legalsReducer.trmsOfService.content,
        trmsOfSvcfetching: state.legalsReducer.trmsOfService.fetching,
        features: state.homeReducer.features,
        signin: state.cognitoLoginReducer.signin,
        userDetails: state.userDetailsReducer.userDetails
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchTrmsOfSvcContent: () => dispatch({ type: FETCH_TRM_OF_SVC_REQUEST })
    };
};

// Named export WITHOUT withMsal for unit tests (withStyles so unwrap() works)
export const LoginComponentTest = withStyles(styles)(Login);
export default withMsal(reduxForm({ form: 'Login' })(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Login))));

